import { useMemo } from 'react';
import {
    PreviewUserDataFragment,
    UserTagOptionDataFragment,
    useGetUserListByTypeQuery,
    useListUserTagOptionsQuery,
    UserType,
} from '../../../../../api';
import { InviteQuoteData } from '../types';

const useInviteQuoteData = (): InviteQuoteData => {
    const { data: userTagsData } = useListUserTagOptionsQuery({
        fetchPolicy: 'cache-and-network',
    });

    const { data: dealersData } = useGetUserListByTypeQuery({
        fetchPolicy: 'cache-and-network',
        variables: { type: UserType.Dealer },
    });

    const tags = useMemo<UserTagOptionDataFragment[]>(() => userTagsData?.userTags ?? [], [userTagsData?.userTags]);
    const dealers = useMemo<PreviewUserDataFragment[]>(
        () => dealersData?.users.items ?? [],
        [dealersData?.users.items]
    );

    return { dealers, tags };
};

export default useInviteQuoteData;
